/**
 * @fileoverview gRPC-Web generated client stub for acompanha.quotes.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/quotes/v1/quotes.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.quotes = {};
proto.acompanha.quotes.v1 = require('./quotes_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.quotes.v1.QuotesServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.quotes.v1.QuotesServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.quotes.v1.ListQuotesRequest,
 *   !proto.acompanha.quotes.v1.ListQuotesResponse>}
 */
const methodDescriptor_QuotesService_ListQuotes = new grpc.web.MethodDescriptor(
  '/acompanha.quotes.v1.QuotesService/ListQuotes',
  grpc.web.MethodType.UNARY,
  proto.acompanha.quotes.v1.ListQuotesRequest,
  proto.acompanha.quotes.v1.ListQuotesResponse,
  /**
   * @param {!proto.acompanha.quotes.v1.ListQuotesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.quotes.v1.ListQuotesResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.quotes.v1.ListQuotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.quotes.v1.ListQuotesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.quotes.v1.ListQuotesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.quotes.v1.QuotesServiceClient.prototype.listQuotes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/ListQuotes',
      request,
      metadata || {},
      methodDescriptor_QuotesService_ListQuotes,
      callback);
};


/**
 * @param {!proto.acompanha.quotes.v1.ListQuotesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.quotes.v1.ListQuotesResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.quotes.v1.QuotesServicePromiseClient.prototype.listQuotes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/ListQuotes',
      request,
      metadata || {},
      methodDescriptor_QuotesService_ListQuotes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.quotes.v1.GetQuoteRequest,
 *   !proto.acompanha.quotes.v1.GetQuoteResponse>}
 */
const methodDescriptor_QuotesService_GetQuote = new grpc.web.MethodDescriptor(
  '/acompanha.quotes.v1.QuotesService/GetQuote',
  grpc.web.MethodType.UNARY,
  proto.acompanha.quotes.v1.GetQuoteRequest,
  proto.acompanha.quotes.v1.GetQuoteResponse,
  /**
   * @param {!proto.acompanha.quotes.v1.GetQuoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.quotes.v1.GetQuoteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.quotes.v1.GetQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.quotes.v1.GetQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.quotes.v1.GetQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.quotes.v1.QuotesServiceClient.prototype.getQuote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/GetQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_GetQuote,
      callback);
};


/**
 * @param {!proto.acompanha.quotes.v1.GetQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.quotes.v1.GetQuoteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.quotes.v1.QuotesServicePromiseClient.prototype.getQuote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/GetQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_GetQuote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.quotes.v1.CreateQuoteRequest,
 *   !proto.acompanha.quotes.v1.CreateQuoteResponse>}
 */
const methodDescriptor_QuotesService_CreateQuote = new grpc.web.MethodDescriptor(
  '/acompanha.quotes.v1.QuotesService/CreateQuote',
  grpc.web.MethodType.UNARY,
  proto.acompanha.quotes.v1.CreateQuoteRequest,
  proto.acompanha.quotes.v1.CreateQuoteResponse,
  /**
   * @param {!proto.acompanha.quotes.v1.CreateQuoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.quotes.v1.CreateQuoteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.quotes.v1.CreateQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.quotes.v1.CreateQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.quotes.v1.CreateQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.quotes.v1.QuotesServiceClient.prototype.createQuote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/CreateQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_CreateQuote,
      callback);
};


/**
 * @param {!proto.acompanha.quotes.v1.CreateQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.quotes.v1.CreateQuoteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.quotes.v1.QuotesServicePromiseClient.prototype.createQuote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/CreateQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_CreateQuote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.quotes.v1.UpdateQuoteRequest,
 *   !proto.acompanha.quotes.v1.UpdateQuoteResponse>}
 */
const methodDescriptor_QuotesService_UpdateQuote = new grpc.web.MethodDescriptor(
  '/acompanha.quotes.v1.QuotesService/UpdateQuote',
  grpc.web.MethodType.UNARY,
  proto.acompanha.quotes.v1.UpdateQuoteRequest,
  proto.acompanha.quotes.v1.UpdateQuoteResponse,
  /**
   * @param {!proto.acompanha.quotes.v1.UpdateQuoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.quotes.v1.UpdateQuoteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.quotes.v1.UpdateQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.quotes.v1.UpdateQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.quotes.v1.QuotesServiceClient.prototype.updateQuote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/UpdateQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_UpdateQuote,
      callback);
};


/**
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.quotes.v1.UpdateQuoteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.quotes.v1.QuotesServicePromiseClient.prototype.updateQuote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/UpdateQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_UpdateQuote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.quotes.v1.DeleteQuoteRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_QuotesService_DeleteQuote = new grpc.web.MethodDescriptor(
  '/acompanha.quotes.v1.QuotesService/DeleteQuote',
  grpc.web.MethodType.UNARY,
  proto.acompanha.quotes.v1.DeleteQuoteRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.quotes.v1.DeleteQuoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.quotes.v1.DeleteQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.quotes.v1.QuotesServiceClient.prototype.deleteQuote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/DeleteQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_DeleteQuote,
      callback);
};


/**
 * @param {!proto.acompanha.quotes.v1.DeleteQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.quotes.v1.QuotesServicePromiseClient.prototype.deleteQuote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/DeleteQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_DeleteQuote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.quotes.v1.UpdateQuoteStatusRequest,
 *   !proto.acompanha.quotes.v1.UpdateQuoteStatusResponse>}
 */
const methodDescriptor_QuotesService_UpdateQuoteStatus = new grpc.web.MethodDescriptor(
  '/acompanha.quotes.v1.QuotesService/UpdateQuoteStatus',
  grpc.web.MethodType.UNARY,
  proto.acompanha.quotes.v1.UpdateQuoteStatusRequest,
  proto.acompanha.quotes.v1.UpdateQuoteStatusResponse,
  /**
   * @param {!proto.acompanha.quotes.v1.UpdateQuoteStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.quotes.v1.UpdateQuoteStatusResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.quotes.v1.UpdateQuoteStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.quotes.v1.UpdateQuoteStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.quotes.v1.QuotesServiceClient.prototype.updateQuoteStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/UpdateQuoteStatus',
      request,
      metadata || {},
      methodDescriptor_QuotesService_UpdateQuoteStatus,
      callback);
};


/**
 * @param {!proto.acompanha.quotes.v1.UpdateQuoteStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.quotes.v1.UpdateQuoteStatusResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.quotes.v1.QuotesServicePromiseClient.prototype.updateQuoteStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/UpdateQuoteStatus',
      request,
      metadata || {},
      methodDescriptor_QuotesService_UpdateQuoteStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.quotes.v1.ArchiveQuoteRequest,
 *   !proto.acompanha.quotes.v1.ArchiveQuoteResponse>}
 */
const methodDescriptor_QuotesService_ArchiveQuote = new grpc.web.MethodDescriptor(
  '/acompanha.quotes.v1.QuotesService/ArchiveQuote',
  grpc.web.MethodType.UNARY,
  proto.acompanha.quotes.v1.ArchiveQuoteRequest,
  proto.acompanha.quotes.v1.ArchiveQuoteResponse,
  /**
   * @param {!proto.acompanha.quotes.v1.ArchiveQuoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.quotes.v1.ArchiveQuoteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.quotes.v1.ArchiveQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.quotes.v1.ArchiveQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.quotes.v1.ArchiveQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.quotes.v1.QuotesServiceClient.prototype.archiveQuote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/ArchiveQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_ArchiveQuote,
      callback);
};


/**
 * @param {!proto.acompanha.quotes.v1.ArchiveQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.quotes.v1.ArchiveQuoteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.quotes.v1.QuotesServicePromiseClient.prototype.archiveQuote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/ArchiveQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_ArchiveQuote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.quotes.v1.UnarchiveQuoteRequest,
 *   !proto.acompanha.quotes.v1.UnarchiveQuoteResponse>}
 */
const methodDescriptor_QuotesService_UnarchiveQuote = new grpc.web.MethodDescriptor(
  '/acompanha.quotes.v1.QuotesService/UnarchiveQuote',
  grpc.web.MethodType.UNARY,
  proto.acompanha.quotes.v1.UnarchiveQuoteRequest,
  proto.acompanha.quotes.v1.UnarchiveQuoteResponse,
  /**
   * @param {!proto.acompanha.quotes.v1.UnarchiveQuoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.quotes.v1.UnarchiveQuoteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.quotes.v1.UnarchiveQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.quotes.v1.UnarchiveQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.quotes.v1.UnarchiveQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.quotes.v1.QuotesServiceClient.prototype.unarchiveQuote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/UnarchiveQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_UnarchiveQuote,
      callback);
};


/**
 * @param {!proto.acompanha.quotes.v1.UnarchiveQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.quotes.v1.UnarchiveQuoteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.quotes.v1.QuotesServicePromiseClient.prototype.unarchiveQuote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/UnarchiveQuote',
      request,
      metadata || {},
      methodDescriptor_QuotesService_UnarchiveQuote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest,
 *   !proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse>}
 */
const methodDescriptor_QuotesService_ConvertQuoteToCheckout = new grpc.web.MethodDescriptor(
  '/acompanha.quotes.v1.QuotesService/ConvertQuoteToCheckout',
  grpc.web.MethodType.UNARY,
  proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest,
  proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse,
  /**
   * @param {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.quotes.v1.QuotesServiceClient.prototype.convertQuoteToCheckout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/ConvertQuoteToCheckout',
      request,
      metadata || {},
      methodDescriptor_QuotesService_ConvertQuoteToCheckout,
      callback);
};


/**
 * @param {!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.quotes.v1.ConvertQuoteToCheckoutResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.quotes.v1.QuotesServicePromiseClient.prototype.convertQuoteToCheckout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.quotes.v1.QuotesService/ConvertQuoteToCheckout',
      request,
      metadata || {},
      methodDescriptor_QuotesService_ConvertQuoteToCheckout);
};


module.exports = proto.acompanha.quotes.v1;

